import { render, staticRenderFns } from "./GlobalChangeDeworn.vue?vue&type=template&id=495a22c4&scoped=true"
import script from "./GlobalChangeDeworn.vue?vue&type=script&lang=js"
export * from "./GlobalChangeDeworn.vue?vue&type=script&lang=js"
import style0 from "./GlobalChangeDeworn.vue?vue&type=style&index=0&id=495a22c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495a22c4",
  null
  
)

export default component.exports